/** Percentage points; an unknown or non-positive denominator does not mean 0%. */
export function conversionPercentage(numerator, denominator) {
  if (numerator === null || numerator === undefined || denominator === null || denominator === undefined) return null
  if (!Number.isFinite(numerator) || !Number.isFinite(denominator) || numerator < 0 || denominator <= 0) return null
  return numerator / denominator * 100
}
